import { AbstractControl, ValidatorFn } from '@angular/forms';


export class CustomNumberValidator {
    static checkLimit(min: number, max: number): ValidatorFn {
        return (c: AbstractControl): { [key: string]: boolean } | null => {
            if (c.value && (isNaN(c.value) || c.value <= min || c.value >= max)) {
                return { 'valid': true };
            }
            return null;
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/common/validator/number.validator.ts